namespace $ {
	const { rem } = $mol_style_unit

	$mol_style_define($bog_ainews_app_settings, {})
}
